export type TAppRouteKey =
  | 'login'
  | 'dashboard'
  | 'payments'
  | 'h2hPayments'
  | 'withdrawals'
  | 'config'
  | 'users'
  | 'shops'
  | 'shopCommissions'
  | 'transactions'
  | 'paymentSystems'
  | 'paymentMethods'
  | 'conversionPairs'
  | 'withdrawalMethods'
  | 'whitelist';

export type TAppRoute =
  | 'login'
  | 'dashboard'
  | 'payments'
  | 'h2h-payments'
  | 'withdrawals'
  | 'config'
  | 'users'
  | 'shops'
  | 'shop-commissions'
  | 'transactions'
  | 'payment-systems'
  | 'payment-methods'
  | 'conversion-pairs'
  | 'withdrawal-methods'
  | 'whitelist';

export const appRoutes: Record<TAppRouteKey, TAppRoute> = {
  login: 'login',
  dashboard: 'dashboard',
  payments: 'payments',
  h2hPayments: 'h2h-payments',
  withdrawals: 'withdrawals',
  config: 'config',
  users: 'users',
  shops: 'shops',
  shopCommissions: 'shop-commissions',
  transactions: 'transactions',
  paymentSystems: 'payment-systems',
  paymentMethods: 'payment-methods',
  conversionPairs: 'conversion-pairs',
  withdrawalMethods: 'withdrawal-methods',
  whitelist: 'whitelist',
};
